module.exports = __webpack_public_path__ + "img/bg.9b3125fc.png";